import { Routes } from '@angular/router';

import { Authority } from 'app/config/authority.constants';
import { UserRouteAccessService } from 'app/core/auth/user-route-access.service';
import { errorRoute } from './layouts/error/error.route';

import NavbarComponent from './layouts/navbar/navbar.component';
import LoginComponent from './login/login.component';
import { SedcardGalleryComponent } from './sedcard/sedcard-gallery/sedcard-gallery.component';
import {ASC} from "./config/navigation.constants";
import {BlogComponent} from "./blog/overview/blog/blog.component";
import {MediaComponent} from "./media/media.component";
import {InstitutionComponent} from "./institution/institution.component";

const routes: Routes = [
  {
    path: '',
    component: BlogComponent,
    title: 'home.title',
  },
  {
    path: '',
    component: NavbarComponent,
    outlet: 'navbar',
  },
  {
    path: 'admin',
    data: {
      authorities: [Authority.ADMIN],
    },
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./admin/admin.routes'),
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.route'),
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'login.title',
  },
  {
    path: '',
    loadChildren: () => import(`./entities/entity.routes`),
  },
  {
    path: 'sexualbegleiterin',
    component: SedcardGalleryComponent,
    title: 'xcareApp.sedcard.home.title',
    data: {
      defaultSort: 'id,' + ASC,
    }
  },
  {
    path: 'medien',
    component: MediaComponent,
    title: 'media.title',
  },
  {
    path: 'info',
    loadChildren: () => import('./infos/info.routes')
  },
  {
    path: 'angebote-fur-institutionen',
    component: InstitutionComponent,
    title: 'institutions.title',
  },
  {
    path: 'messenger',
    loadChildren: () => import('./messenger/messenger.routes')
  },
  {
    path: 'blog',
    loadChildren: () => import('./blog/blog.routes')
  },
  {
    path: 'legal',
    loadChildren: () => import('./legal/legal.routes')
  },
  ...errorRoute,
];

export default routes;
